<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{ this.$route.name }}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-7">
            <div class="col-sm-4">
              <a v-if="getRoleId != '33'" @click="openAddModalSkema()" class="btn-primary"><i
                  class="fas fa-plus-square mr-5"></i>Add</a>
            </div>
          </div>
          <div class="col-sm-5 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control"
                    placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
          :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
          <template v-slot:cell(action)="data">
            <b-btn v-if="getRoleId != '33'" @click="openModalSkema(data.item)" size="sm" class="btn-table green me-2"><i
                class="fas fa-pen mr-5"></i>Edit</b-btn>
            <b-button v-if="getRoleId != '33'" size="sm" v-on:click="deleteItem(data.item.id)" class="btn-table danger">
              <i class="fas fa-times"></i> Delete
            </b-button>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage" :total-pages="totalPage"
          @page-changed="pageOneChanged" prev-text="Prev" next-text="Next" />
      </div>
    </div>

    <!-- modal edit -->
    <b-modal modal-class="modal-custom-image" size="lg" hide-footer :ref="'edit_skema_amount'" title="Edit Skema">
      <div class="p-10">
        <form @submit.prevent="onSave()">
          <b-row class="mb-3">
            <b-col md="6">
              <label for="sales_id">Rule Type</label>
              <div class="mb-10">
                <b-form-select name="sales_id" v-model="selectedItem.point_type" class="form-control border-bottom">
                  <option value="" selected>Please select</option>
                  <option value="AUTOPAY_YEARLY">Auto Pay Yearly</option>
                  <option value="AUTOPAY_MONTHLY">Auto Pay Monthly</option>
                  <option value="CHECK_IN_MONTHLY">Check In Monthly</option>
                  <option value="CHECK_IN_DAILY">Check In Daily</option>
                  <option value="BUY_MEMBERSHIP">Buy Membership</option>
                  <option value="BUY_PT_SESSION">Buy PT Session</option>
                  <option value="PT_RUNNING">PT Running</option>
                  <option value="CLASS_RUNNING">Class Running</option>
                </b-form-select>
              </div>
            </b-col>
            <b-col md="12">
              <label for="sales_id">Rule Name</label>
              <div class="mb-10">
                <input type="text" name="point" v-model="selectedItem.rule_name" class="form-control border-bottom"
                  placeholder="Amount" />
              </div>
            </b-col>
            <b-col md="12">
              <label for="sales_id">Rule Description</label>
              <div class="mb-10">
                <!-- <input type="text" name="point" v-model="selectedItem.description" class="form-control border-bottom"
                  placeholder="Decription" /> -->
                  <div>
                  <quill-editor class="editor-custom" name="purpose" ref="myTextEditor" v-model="selectedItem.description"
                    :options="editorOption"></quill-editor>
                </div>
              </div>
            </b-col>
            <b-col md="6">
              <label for="sales_id">Amount Type</label>
              <div class="mb-10">
                <b-form-select name="sales_id" v-model="selectedItem.type" class="form-control border-bottom">
                  <option value="" selected>Please select</option>
                  <option value="percent">Percent</option>
                  <option value="point">Point</option>
                </b-form-select>
              </div>
            </b-col>
            <b-col md="6">
              <label for="sales_id">Amount</label>
              <div class="mb-10">
                <input v-if="selectedItem.type == 'point'" type="number" name="point" v-model="selectedItem.amount"
                  class="form-control border-bottom" placeholder="Amount" />
                <input v-else type="number" min="0" max="100" step="0.01" name="percent" v-model="selectedItem.amount"
                  class="form-control border-bottom" placeholder="Percent %" />
              </div>
            </b-col>
            <b-col md="6">
              <label for="sales_id">Cap Value</label>
              <div class="mb-10">
                <input type="number" name="point" v-model="selectedItem.cap_value" class="form-control border-bottom"
                  placeholder="Cap Value" />
              </div>
            </b-col>
            <b-col md="6" class="mb-3">
              <label for="sales_id">Unit Type</label>
              <div class="mb-10">
                <b-form-select name="sales_id" v-model="selectedItem.unit" class="form-control border-bottom">
                  <option value="" selected>Please select</option>
                  <option value="per check-in">Per Check-In</option>
                  <option value="month 12">Month 12</option>
                  <option value="per spend">Per Spend</option>
                  <option value="per month">Per Month</option>
                </b-form-select>
              </div>
            </b-col>
            <b-col md="12" class="mb-3">
              <label for="sales_id">Wording (EN)</label>
              <div class="mb-10">
                <textarea placeholder="Enter Wording" name="wording" id="wording" v-model="selectedItem.wording"
                  class="form-control border-bottom w-100"></textarea>
              </div>
            </b-col>

            <b-col md="12">
              <label for="sales_id">Wording (ID)</label>
              <div class="mb-10">
                <textarea placeholder="Enter Wording" name="wording" id="wording" v-model="selectedItem.wording_en"
                  class="form-control border-bottom w-100"></textarea>
              </div>
            </b-col>
          </b-row>
          <div class="mt-5 text-right">
            <button type="submit" class="btn-primary">Save</button>
          </div>
        </form>
      </div>
    </b-modal>

    <!-- modal -->
    <b-modal modal-class="modal-custom-image" size="lg" hide-footer :ref="'add_skema_amount'" title="Add Skema">
      <div class="p-10">
        <form @submit.prevent="onSubmit()">
          <b-row class="mb-3">
            <b-col md="6">
              <label for="sales_id">Rule Type</label>
              <div class="mb-10">
                <b-form-select name="sales_id" v-model="addData.point_type" class="form-control border-bottom">
                  <option value="" selected>Please select</option>
                  <option value="AUTOPAY_YEARLY">Auto Pay Yearly</option>
                  <option value="AUTOPAY_MONTHLY">Auto Pay Monthly</option>
                  <option value="CHECK_IN_MONTHLY">Check In Monthly</option>
                  <option value="CHECK_IN_DAILY">Check In Daily</option>
                  <option value="BUY_MEMBERSHIP">Buy Membership</option>
                  <option value="BUY_PT_SESSION">Buy PT Session</option>
                  <option value="PT_RUNNING">PT Running</option>
                  <option value="CLASS_RUNNING">Class Running</option>
                </b-form-select>
              </div>
            </b-col>
            <b-col md="12">
              <label for="sales_id">Rule Name</label>
              <div class="mb-10">
                <input type="text" name="point" v-model="addData.rule_name" class="form-control border-bottom"
                  placeholder="Amount" />
              </div>
            </b-col>
            <b-col md="12">
              <label for="sales_id">Rule Description</label>
              <div class="mb-10">
                <!-- <input type="text" name="point" v-model="addData.description" class="form-control border-bottom"
                  placeholder="Decription" /> -->
                <div>
                  <quill-editor class="editor-custom" name="purpose" ref="myTextEditor" v-model="addData.description"
                    :options="editorOption"></quill-editor>
                </div>
              </div>
            </b-col>
            <b-col md="6">
              <label for="sales_id">Amount Type</label>
              <div class="mb-10">
                <b-form-select name="sales_id" v-model="addData.type" class="form-control border-bottom">
                  <option value="" selected>Please select</option>
                  <option value="percent">Percent</option>
                  <option value="point">Point</option>
                </b-form-select>
              </div>
            </b-col>
            <b-col md="6">
              <label for="sales_id">Amount</label>
              <div class="mb-10">
                <input v-if="addData.type == 'point'" type="number" name="point" v-model="addData.amount"
                  class="form-control border-bottom" placeholder="Amount" />
                <input v-else type="number" min="0" max="100" step="0.01" name="percent" v-model="addData.amount"
                  class="form-control border-bottom" placeholder="Percent %" />
              </div>
            </b-col>
            <b-col md="6">
              <label for="sales_id">Cap Value</label>
              <div class="mb-10">
                <input type="number" name="point" v-model="addData.cap_value" class="form-control border-bottom"
                  placeholder="Cap Value" />
              </div>
            </b-col>
            <b-col md="6">
              <label for="sales_id">Unit Type</label>
              <div class="mb-10">
                <b-form-select name="sales_id" v-model="addData.unit" class="form-control border-bottom">
                  <option value="" selected>Please select</option>
                  <option value="per check-in">Per Check-In</option>
                  <option value="month 12">Month 12</option>
                  <option value="per spend">Per Spend</option>
                  <option value="per month">Per Month</option>
                </b-form-select>
              </div>
            </b-col>
            <b-col md="12">
              <label for="sales_id">Custom Wording</label>
              <div class="mb-10">
                <textarea placeholder="Enter Wording" name="wording" id="wording" v-model="addData.wording"
                  class="form-control border-bottom w-100"></textarea>
              </div>
            </b-col>
          </b-row>
          <div class="mt-5 text-right">
            <button type="submit" class="btn-primary">Save</button>
          </div>
        </form>
      </div>
    </b-modal>



    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'
import moment from 'moment'
import { quillEditor } from 'vue-quill-editor'

export default {
  name: 'frontend_groupfitness',
  components: {
    'app-pagination': Pagination,
    quillEditor
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loadingActive: false,
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote'],
            [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          ]
        }
      },
      fields: [
        {
          key: 'rule_name',
          label: 'Rule',
          sortable: false
        },
        // {
        //   key: 'description',
        //   label: 'Description',
        //   sortable: false
        // },
        {
          key: 'amount',
          label: 'Amount',
          sortable: false,
          formatter: (value, key, item) => {
            if (item.type == 'percent') {
              return value + ' %'
            } else {
              return 'Rp. ' + parseFloat(item.amount).toLocaleString('id-ID', { maximumFractionDigits: 2 })
            }
          },
        },
        {
          key: 'type',
          label: 'Type',
          sortable: false
        },
        {
          key: 'unit',
          label: 'Unit',
          sortable: false
        },
        {
          key: 'cap_value',
          label: 'Cap Value',
          sortable: false
        },
        {
          key: 'action',
          label: 'Action',
          sortable: false
        }
      ],
      items: [],
      sortType: 'desc',
      sortBy: 'id',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      getRoleId: Auth.Session.get().paradigm_role,
      totalPage: 0,
      selectedItem: {
        amount: 0,
        wording: '',
        wording_en: '',
      },
      addData: {
        rule_name: '',
        description: '',
        amount: 0,
        type: 'point',
        wording: '',
        point_type: '',
        unit: '',
        cap_value: 0
      }
    }
  },
  computed: {
    name() {
      return this.$route.name
    }
  },
  methods: {
    showModal(id) {
      this.$refs[id].show()
    },
    onSave() {
      if (this.selectedItem.amount == 0) {
        this.$swal('Failed', 'Amount must be greater than 0', 'warning')
        return
      }

      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Save it!"
        })
        .then(result => {
          if (result.value) {
            this.loadingActive = true
            const body = {
              rule_name: this.selectedItem.rule_name,
              description: this.selectedItem.description,
              amount: this.selectedItem.amount,
              wording: this.selectedItem.wording,
              wording_en: this.selectedItem.wording_en
            }

            axios.put('crm/v1/member_point_scheme/' + this.selectedItem.id, body).then(response => {
              this.loadingActive = false
              this.fetchData()
              this.$swal('Success', 'Amount successfully updated', 'success')
              this.$refs['edit_skema_amount'].hide()
            }).catch((err) => {
              this.loadingActive = false
              this.$swal('Failed', 'Failed to update amount!', 'error')
              console.log(err)
            })
          }
        })
    },

    onSubmit() {
      // validate adddata
      if (this.addData.amount == 0) {
        this.$swal('Failed', 'Amount must be greater than 0', 'warning')
        return
      } else if (this.addData.description == '') {
        this.$swal('Failed', 'Description must be filled', 'warning')
        return
      } else if (this.addData.rule_name == '') {
        this.$swal('Failed', 'Rule name must be filled', 'warning')
        return
      } else if (this.addData.type == '') {
        this.$swal('Failed', 'Type must be selected', 'warning')
        return
      } else if (this.addData.point_type == '') {
        this.$swal('Failed', 'Point type must be selected', 'warning')
        return
      }


      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Save it!"
        })
        .then(result => {
          if (result.value) {
            this.loadingActive = true

            axios.post('crm/v1/member_point_scheme/', this.addData).then(response => {
              this.loadingActive = false
              this.fetchData()
              this.$swal('Success', 'Successfull!', 'success')
              this.$refs['add_skema_amount'].hide()
            }).catch((err) => {
              this.loadingActive = false
              this.$swal('Failed', 'Failed to update amount!', 'error')
              console.log(err)
            })
          }
        })
    },
    deleteItem(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if (result.value) {

          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.delete('crm/v1/member_point_scheme/'.concat(event)).then(response => {
            this.$swal('Deleted', 'You successfully deleted this item', 'success')
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    openModalSkema(item) {
      this.selectedItem = item
      this.showModal('edit_skema_amount')
    },
    openAddModalSkema() {
      this.showModal('add_skema_amount')
    },
    statusCodes(status) {
      return (status === 200 || status === '200') ? 'success'
        : (status === 202 || status === 202) ? 'warning' : 'danger'
    },
    pageOneChanged(pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked(searchEvent) {
      this.fetchData()
    },
    getBadge(status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount(items) {
      return items.length
    },
    openPage(event) {
      this.$router.push(event)
    },
    parseImg(value) {
      return Auth.apiUrl + 'fitness/v1/img/frontend/pha/' + value
    },
    fetchData() {
      this.loadingActive = true;
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('crm/v1/member_point_scheme?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
        this.loadingActive = false;
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
        this.loadingActive = false
      })
    }
  },
  // sockets:{
  //   connect: function () {
  //     console.log('socket connected')
  //   },
  //   message: function(data) {
  //     console.log('Socket Connected', data)
  //   },
  //   face_log:  function(event) {
  //     console.log(event)
  //     this.fetchData()
  //   }
  // },
  created() {
    this.fetchData()
    //   this.$socket.emit('echo', { msg: 'Success Connected' })
  }
}
</script>

<style></style>
